export default __webpack_public_path__ + "static/media/places.ca821754.svg";